<app-feature-hero
    variant="ims"
    title="Hybrid Cloud Monitoring"
    description="Future-proof your hybrid cloud environment from one place."
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Unlock infra ROI with our hybrid cloud monitoring tools</h2>
                <p class="section-paragraph">Infraon ITIM comes with the hybrid cloud monitoring feature to integrate
                    how you track your physical and virtual IT infrastructure from a single location. Empower your IT
                    and business teams with rich dashboard-driven, single-click reporting experiences.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/website-managment-main.png" width="80%"
                    alt="availability monitoring">
            </div>
        </div>
    </div>
</section>


<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Key Feature</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/cloud-01.svg"
                    alt="hybrid cloud">
            </div>
            <p class="section-title-s">Hybrid Cloud IT Visibility</p>
            <p class="section-paragraph-s">Seamlessly manage your applications and data spread over private/public cloud
                and on-premises systems. Avoid having to switch tools and address service gaps across the hybrid
                ecosystem.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/map-folded.svg"
                    alt="hybrid dependencies mapping">
            </div>
            <p class="section-title-s">Auto Discovery & Dependency Mapping</p>
            <p class="section-paragraph-s">Automatically discover any additions to your hybrid infrastructure. Ensure
                instant cross-correlation capabilities to map dependencies between applications.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/lightning-01.svg"
                    alt="hybrid cloud analytics">
            </div>
            <p class="section-title-s">Predictive Hybrid Cloud Analytics</p>
            <p class="section-paragraph-s">Get predictive data insights about hybrid infrastructure health and
                performance. Use actionable intelligence to isolate the root cause of application, server, or data
                issues.</p>
        </div>
    </div>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/alert.svg"
                    alt="fault detection">
            </div>
            <p class="section-title-s">Integrated Fault & Incident Management</p>
            <p class="section-paragraph-s">Quickly resolve faults and prevent incidents with inbuilt troubleshooting.
                Use workflow automation to extract real-time event diagnosis data and recommend Next Best Actions.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/document.svg"
                    alt="reporting">
            </div>
            <p class="section-title-s">Consolidated Reporting</p>
            <p class="section-paragraph-s">Leverage single-click reporting capabilities to get in-depth information
                about your multi-vendor cloud and on-premises infrastructure.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/bell-icon.svg"
                    alt="alerts">
            </div>
            <p class="section-title-s">Centralized Alerts & Notifications</p>
            <p class="section-paragraph-s">Customize alerts and notifications based on your service or business criteria
                – equipped with a powerful, intuitive dashboard.</p>
        </div>
    </div>
</section>


<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>

                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">KPI Dashboards</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Report Exports</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Bulk Excel Import/Export</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Scheduled Reports</p>
                        </li>
                    </ul>
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Reports</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Roles</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Alerts</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Customizable Fields</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute"
                style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-ims/hybrid-cloud/woman-1.webp" class="w-60" alt="woman point at features">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a [routerLink]="['/registration']" [queryParams]="{ type: 'trial' }" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container">
        <h2 class="section-title text-center">Related Content</h2>

        <div class="row mx-0">
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        Cloud Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/cloud-monitoring-solutions">Know more</a>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        Server Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/server-monitoring">Know more</a>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        IT Network Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/it-network-monitoring">Know more</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

<app-faqs [faqs]="faqs" [theme]="'nms-theme'"></app-faqs>